import React from 'react'
import { List, Datagrid, TextField, Filter, TextInput, ShowButton } from 'react-admin'

const ReportFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

const ReportList = (props) => (
  <List hasCreate={false} filters={<ReportFilter />} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="title" />
      <ShowButton />
    </Datagrid>
  </List>
)

export default ReportList
